module.exports = __webpack_public_path__ + "img/BRCA3_CD8T.ee1919ba.png";